/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_Page_Http_Not_FoundInputs */

const de_commons_error_page_http_not_found = /** @type {(inputs: Commons_Error_Page_Http_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite nicht gefunden`)
};

/** @type {(inputs: Commons_Error_Page_Http_Not_FoundInputs) => LocalizedString} */
const en_commons_error_page_http_not_found = de_commons_error_page_http_not_found;

/**

* @param {Commons_Error_Page_Http_Not_FoundInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_page_http_not_found = /** @type {((inputs?: Commons_Error_Page_Http_Not_FoundInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_Page_Http_Not_FoundInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_page_http_not_found(inputs)
	return en_commons_error_page_http_not_found(inputs)
});